import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

export const ContactStep = ({ form, update }) => (
  <div className="space-y-6">
    <h3 className="font-serif-display text-2xl text-white mb-2">Cuéntanos de ti</h3>
    <div>
      <Label className="text-white/60 text-xs uppercase tracking-wider">Nombre</Label>
      <Input
        data-testid="quote-input-name"
        value={form.name}
        onChange={(e) => update("name", e.target.value)}
        className="bg-black border-white/20 text-white mt-2"
        placeholder="Tu nombre completo"
      />
    </div>
    <div>
      <Label className="text-white/60 text-xs uppercase tracking-wider">Teléfono</Label>
      <Input
        data-testid="quote-input-phone"
        value={form.phone}
        onChange={(e) => update("phone", e.target.value)}
        className="bg-black border-white/20 text-white mt-2"
        placeholder="442 123 4567"
      />
    </div>
  </div>
);
